const CONTENT_TYPE_ARTICLE = 'article'
const CONTENT_TYPE_QUESTION = 'question'
const CONTENT_TYPE_DISCUSSION = 'discussion'
const CONTENT_TYPE_IDEA = 'idea'
const CONTENT_TYPE_PRODUCT_UPDATE = 'productUpdate'

export type ContentType = 'article' | 'question' | 'discussion' | 'idea' | 'productUpdate'

export function isArticle (contentType: ContentType) {
  return contentType === CONTENT_TYPE_ARTICLE
}

export function isQuestion (contentType: ContentType) {
  return contentType === CONTENT_TYPE_QUESTION
}

export function isDiscussion (contentType: ContentType) {
  return contentType === CONTENT_TYPE_DISCUSSION
}

export function isIdea (contentType: ContentType) {
  return contentType === CONTENT_TYPE_IDEA
}

export function isProductUpdate (contentType: ContentType) {
  return contentType === CONTENT_TYPE_PRODUCT_UPDATE
}
